// Lib
import { DealerLMState } from 'features/Dealers/Listings/Data/state/reducer';
import { Action } from 'redux';

// Constants
import * as ACTIONS from './actionTypes';
import { UIListingLocation } from './types';

export interface ActionGetDealerEnginePreview extends Action {
    listingId: string
    engineId: string
}

export const getDealerEnginePreview = (engineId: string, listingId: string,): ActionGetDealerEnginePreview => ({
    type: ACTIONS.GET_DEALER_ENGINE_PREVIEW_API_REQUEST,
    listingId,
    engineId
});

export interface ActionGetDealerEnginePreviewSuccess extends Action {
    enginePreview: UIListingLocation
}

export const getDealerEnginePreviewSuccess = (enginePreview: UIListingLocation): ActionGetDealerEnginePreviewSuccess => ({
    type: ACTIONS.GET_DEALER_ENGINE_PREVIEW_API_SUCCESS,
    enginePreview
});

export interface ActionGetDealerEnginePreviewError extends Action {
    error: any
}

export const getDealerEnginePreviewError = (error: any): ActionGetDealerEnginePreviewError => ({
    type: ACTIONS.GET_DEALER_ENGINE_PREVIEW_API_ERROR,
    error
});
